import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "qa-quote-session" }
const _hoisted_2 = { class: "qa-qs-settings" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "underline" }, "skipped", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_5 = { class: "qa-qs-display" }
const _hoisted_6 = { class: "qa-qs-top-controls" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Auto Advance ")
const _hoisted_8 = { class: "qa-qs-stacks" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Unquoted ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Unreviewed ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Complete ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_QuizCard = _resolveComponent("QuizCard")!
  const _component_SessionControls = _resolveComponent("SessionControls")!
  const _component_CardStackDisplay = _resolveComponent("CardStackDisplay")!
  const _directive_touch_options = _resolveDirective("touch-options")!
  const _directive_touch = _resolveDirective("touch")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "qa-qs-swipe-overlay",
      style: _normalizeStyle({
        opacity: _ctx.swipeIndColor ? 0.2 : 0,
        backgroundColor: _ctx.swipeIndColor,
      })
    }, null, 4),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "clear-btn qa-qs-skipped-button",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openSkippedOverlay && _ctx.openSkippedOverlay(...args)), ["prevent"]))
      }, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("span", null, "(" + _toDisplayString(_ctx.skipped.length) + ")", 1)
      ]),
      _createVNode(_component_IconButton, {
        icon: "settings",
        onClick: _withModifiers(_ctx.openSettingsOverlay, ["prevent"])
      }, null, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Toggle, {
          id: "auto-continue-toggle",
          modelValue: _ctx.autoAdvance,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.autoAdvance) = $event)),
          title: "auto start recording"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      (_ctx.activeVerseRef)
        ? (_openBlock(), _createBlock(_component_QuizCard, {
            key: 0,
            class: "qa-qs-card",
            "ref-text": _ctx.activeVerseString,
            "verse-text": _ctx.activeVerseText,
            spinner: _ctx.spinner
          }, null, 8, ["ref-text", "verse-text", "spinner"]))
        : _createCommentVNode("", true),
      _createVNode(_component_SessionControls, {
        class: "qa-qs-controls",
        "current-index": _ctx.activeVerseRef?.index,
        mode: _ctx.mode,
        state: _ctx.state
      }, null, 8, ["current-index", "mode", "state"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_CardStackDisplay, {
        verses: _ctx.unquoted,
        class: "qa-color-bg-blue",
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.setMode('quote')), ["prevent"]))
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["verses"]),
      (!_ctx.coachMode)
        ? (_openBlock(), _createBlock(_component_CardStackDisplay, {
            key: 0,
            verses: _ctx.unreviewed,
            class: "qa-color-bg-yellow",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.setMode('review')), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["verses"]))
        : _createCommentVNode("", true),
      _createVNode(_component_CardStackDisplay, {
        verses: _ctx.complete,
        class: "qa-color-bg-green",
        onClick: _withModifiers(_ctx.openCompleteOverlay, ["prevent"])
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      }, 8, ["verses", "onClick"])
    ])
  ])), [
    [_directive_touch_options, { swipeTolerance: 80, disableClick: true }],
    [_directive_touch, _ctx.testSwipe, "swipe"]
  ])
}